<script>
  import { format } from 'svelte-i18n';
  import { Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { calculateUsage } from '@client/utils/usage';

  export let domain = null;
  export let usage = {};

  let stats = null;

  $: stats = calculateUsage(usage);
  $: totalUsage = stats.totals.totalUsagePercentage;
  $: totalOverage = stats.totals.totalOveragePercentage;
</script>

{#if totalOverage > 0}
  <div
    class="tag overage"
    id="domain-overages-{domain._id}"
    class:high={totalOverage >= 75}
    class:medium={totalOverage <= 74 && totalOverage >= 45}
    class:low={totalOverage < 45}
  >
    {$format('label.TOTAL_OVERAGE', { values: { value: totalOverage.toLocaleString() } })}
  </div>

  <Tooltip class="breakdown-tooltip" target="domain-overages-{domain._id}" placement="top">
    <table class="breakdown-table" cellpadding="0" cellspacing="0" border="0">
      <thead>
        <tr>
          <th>{$format('label.TIER')}</th>
          <th>{$format('label.USAGE')}</th>
          <th>{$format('label.SOLD')}</th>
          <th>{$format('label.OVERAGE')}</th>
          <th>{$format('label.UNDERAGE')}</th>
          <th>{$format('label.USAGE')} %</th>
          <th>{$format('label.OVERAGE')} %</th>
        </tr>
      </thead>
      <tbody>
        {#each Object.entries(stats).slice(0, 4) as [tier, metrics]}
          <tr>
            <td>{tier.slice(0, 1).toUpperCase() + tier.slice(1)}</td>
            <td>{metrics.usage.toLocaleString()}</td>
            <td>{metrics.sold.toLocaleString()}</td>
            <td>{metrics.overage.toLocaleString()}</td>
            <td>{metrics.underage.toLocaleString()}</td>
            <td>{metrics.usagePercentage.toLocaleString()}%</td>
            <td>{metrics.overagePercentage.toLocaleString()}%</td>
          </tr>
        {/each}
      </tbody>
    </table>
  </Tooltip>
{/if}

{#if stats}
  <div
    class="tag usage"
    id="domain-usage-{domain._id}"
    class:high={totalUsage >= 75}
    class:low={totalUsage <= 74 && totalUsage >= 0}
  >
    {#if totalUsage > 0}
      <Icon name="arrow-up" />
    {/if}

    {$format('label.TOTAL_USAGE', { values: { value: totalUsage.toLocaleString() } })}

    <Tooltip class="breakdown-tooltip" target="domain-usage-{domain._id}" placement="top">
      <b>{$format('label.LICENSE_USAGE')}</b>

      <table class="breakdown-table" cellpadding="0" cellspacing="0" border="0">
        <thead>
          <tr>
            <th>{$format('label.TIER')}</th>
            <th>{$format('label.USAGE')}</th>
            <th>{$format('label.SOLD')}</th>
            <th>{$format('label.UNDERAGE')}</th>
            <th>{$format('label.USAGE')} %</th>
          </tr>
        </thead>
        <tbody>
          {#each Object.entries(stats).slice(0, 4) as [tier, metrics]}
            <tr>
              <td>{tier.slice(0, 1).toUpperCase() + tier.slice(1)}</td>
              <td>{metrics.usage.toLocaleString()}</td>
              <td>{metrics.sold.toLocaleString()}</td>
              <td>{metrics.underage.toLocaleString()}</td>
              <td>{metrics.usagePercentage.toLocaleString()}%</td>
            </tr>
          {/each}
        </tbody>
      </table>

      {#if usage?.domains?.length}
        <br />

        <b>{$format('label.DOMAINS')}</b>
        <div>
          {usage.domains.slice(0, 5).join(usage.domains.length > 1 ? ', ' : '')}
          {usage.domains.length > 5 ? `+${usage.domains.length - 5}` : ''}
        </div>
      {/if}
    </Tooltip>
  </div>
{/if}

<style lang="scss" src="./usage.scss"></style>
